import {Exclude, Expose, instanceToPlain, plainToInstance, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {MeterEntity, MeterValidator} from "./meter";
import {
  TemporalMeterFlowVolumeTotalEntry,
  TemporalMeterFlowVolumeTotalEntryArrayValidator
} from "./meter-flow-volume-total";
import {EntityIdentifier} from "./entity";

export const FlaggedMeterValidator = t.intersection([
  t.type({
    meter: MeterValidator
  }),
  t.partial({
    flowVolumeFlags: TemporalMeterFlowVolumeTotalEntryArrayValidator,
  }),
]);

export const FlaggedMeterArrayValidator = t.array(FlaggedMeterValidator);

export type FlaggedMeter = t.TypeOf<typeof FlaggedMeterValidator>;
export type FlaggedMeterArray = t.TypeOf<typeof FlaggedMeterArrayValidator>;

@Exclude()
export class FlaggedMeterEntity {
  @Expose()
  @Type(() => MeterEntity)
  meter!: MeterEntity;

  @Expose()
  flowVolumeFlags: TemporalMeterFlowVolumeTotalEntry[] = [];

  /**
   * Constructor for FlaggedMeterEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(plain: FlaggedMeter): FlaggedMeterEntity {
    return plainToInstance(FlaggedMeterEntity, plain, {
      excludeExtraneousValues: true,
    });
  }

  loadPlainValue(): Promise<FlaggedMeter> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(FlaggedMeterValidator, object);
  }

  asPlainValue(): FlaggedMeter {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true
    });
    return validateJSONNow(FlaggedMeterValidator, object);
  }
}

export interface FlaggedMeterSearchCriteria {
  fromDttm?: number;
  toDttm?: number;
  ids?: string[];
  regionIds?: string[];
  categories?: string[];
  entityIds?: EntityIdentifier[];
}
